import { ArrowLeft } from "lucide-react";
import { motion } from "framer-motion";
import { Button } from "./button";
import { LucideIcon } from "lucide-react";

interface MobileOverlayProps {
    icon: LucideIcon;
    title: string;
    description: string;
    onBack?: () => void;
}

const overlayVariants = {
    hidden: { 
        opacity: 0,
        scale: 0.95
    },
    visible: { 
        opacity: 1,
        scale: 1,
        transition: {
            duration: 0.2,
            ease: "easeOut",
            when: "beforeChildren",
            staggerChildren: 0.1
        }
    },
    exit: {
        opacity: 0,
        scale: 0.95,
        transition: {
            duration: 0.2,
            ease: "easeIn"
        }
    }
};

const itemVariants = {
    hidden: { 
        opacity: 0,
        y: 20
    },
    visible: { 
        opacity: 1,
        y: 0,
        transition: {
            duration: 0.3,
            ease: "easeOut"
        }
    }
};

export function MobileOverlay({
    icon: Icon,
    title,
    description,
    onBack
}: MobileOverlayProps) {
    return (
        <motion.div
            initial="hidden"
            animate="visible"
            exit="exit"
            variants={overlayVariants}
            className="fixed inset-0 bg-background z-50 flex flex-col sm:hidden"
        >
            {onBack && (
                <motion.div 
                    variants={itemVariants}
                    className="p-4"
                >
                    <Button
                        variant="ghost"
                        size="icon"
                        onClick={onBack}
                        className="h-8 w-8"
                    >
                        <ArrowLeft className="h-4 w-4" />
                    </Button>
                </motion.div>
            )}

            <motion.div 
                variants={itemVariants}
                className="flex-1 flex items-center justify-center p-6"
            >
                <div className="text-center space-y-6">
                    <motion.div 
                        variants={itemVariants}
                        className="mx-auto w-20 h-20 rounded-full bg-primary/10 flex items-center justify-center ring-4 ring-primary/5"
                    >
                        <Icon className="w-10 h-10 text-primary" />
                    </motion.div>
                    <motion.div 
                        variants={itemVariants}
                        className="space-y-3"
                    >
                        <h3 className="text-2xl font-semibold tracking-tight">{title}</h3>
                        <p className="text-sm text-muted-foreground max-w-xs mx-auto leading-relaxed">
                            {description}
                        </p>
                    </motion.div>
                </div>
            </motion.div>
        </motion.div>
    );
}
